import React from 'react';
import About from '../components/About';
import Download from '../components/Download';

const AboutPage = () => {
  return (
    <>
      <About />
      <Download />
    </>
  );
};

export default AboutPage;